import { AssetScope } from "../assets";
import { z } from "zod";
//
// Abstract
//
export const ImageImportModelType = z.enum(["Url", "FigmaRender"]);
const ImageImportModelBase = z.object({
    scope: AssetScope,
});
//
// Url
//
export const UrlImageImportModel = ImageImportModelBase.extend({
    type: z.literal(ImageImportModelType.enum.Url),
    url: z.string(),
    originKey: z.string(),
    extension: z.string(),
});
//
// Figma Render
//
export const FigmaRenderFormat = z.enum(["Svg", "Png", "Pdf"]);
const FigmaRenderBase = ImageImportModelBase.extend({
    type: z.literal(ImageImportModelType.enum.FigmaRender),
    fileId: z.string(),
    fileVersionId: z.string().optional(),
    nodeId: z.string(),
    originKey: z.string(),
});
export const FigmaPngRenderImportModel = FigmaRenderBase.extend({
    format: z.literal(FigmaRenderFormat.enum.Png),
    scale: z.number(),
});
export const FigmaSvgRenderImportModel = FigmaRenderBase.extend({
    format: z.literal(FigmaRenderFormat.enum.Svg),
    scale: z.number(),
});
export const FigmaRenderImportModel = z.discriminatedUnion("format", [
    FigmaPngRenderImportModel,
    FigmaSvgRenderImportModel,
]);
//
// Union
//
// Unfortunately discriminated union doesn't support inserting another discriminated union
export const ImageImportModel = z.union([
    UrlImageImportModel,
    FigmaRenderImportModel,
]);
//
// Utils
//
export function getFigmaRenderFormatFileExtension(format) {
    switch (format) {
        case "Pdf":
            return "pdf";
        case "Png":
            return "png";
        case "Svg":
            return "svg";
    }
}
